export default __webpack_public_path__ + "7d1a7e5f8b0127ee80bf313c51b5e496.png";